import React, { useState } from "react";
import ModalBody from "reactstrap/lib/ModalBody";
import Modal from "reactstrap/lib/Modal";
import ModalHeader from "reactstrap/lib/ModalHeader";
import { useDropzone } from "react-dropzone";
import TextField from "@material-ui/core/TextField";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
import Tumbs from "./Tumbs";
import Button from "reactstrap/lib/Button";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useDispatch } from "react-redux";
import VersionSection from "../fileManager/temporary/VersionSection";
import { createFileNewVersion } from "../../slice/libraryThunks";
import { LIBRARY_ACCEPTED_FILES } from "../../slice/constants";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  version: {
    marginLeft: 6,
    marginBottom: 8,
    display: "flex",
    justifyContent: "space-between",
  },
  details: {
    flexDirection: "column",
  },
});

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const ReviseModal = (props) => {
  const dispatch = useDispatch();
  const { open, handleOpen, handleClose, content, current } = props;
  const type = content.is_folder ? "folder" : "file";
  const initVer = type === "folder" ? "1.0.0" : content.version;
  const [files, setFiles] = useState([]);
  const [version, setVersion] = useState(suggestionFunc(initVer));
  const classes = useStyles();
  const { title } = content;
  const [expanded, setExpanded] = useState("panel1");

  function suggestionFunc(a) {
    // const a = type === "folder" ? "1.0.0" : content.version;
    let x = a.split(".");
    let first = Number(x[0]);
    let second = Number(x[1]);
    let tirth = Number(x[2]);
    if (tirth + 1 >= 20) {
      if (second + 1 >= 20) {
        first++;
        second = 0;
      } else {
        second++;
      }
      tirth = 0;
    } else {
      tirth++;
    }
    return `${first}.${second}.${tirth}`;
    // setSuggestion(`${first}.${second}.${tirth}`);
    // setVersion(`${first}.${second}.${tirth}`);
  }

  async function handleUploadFile() {
    if (files.length > 0) {
      await dispatch(createFileNewVersion(files[0], content, current, version));
      setFiles([]);
      handleChangeAccordin("panel2")(null, true);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: LIBRARY_ACCEPTED_FILES,
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) => {
          console.log(file);
          return Object.assign(file, {
            preview: URL.createObjectURL(file),
          });
        })
      );
    },
  });

  function handleChangeVersion(e) {
    const { value } = e.target;
    setVersion(value);
  }

  const handleCloseModal = () => {
    setFiles([]);
    handleClose();
  };

  const handleChangeAccordin = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const Thumbs = files.map((file, idx) => (
    <Tumbs
      file={file}
      title={title}
      freeze={true}
      key={`${file.name}_modalFile`}
    />
  ));

  return (
    <Modal toggle={handleCloseModal} handleOpen={handleOpen} isOpen={open}>
      <ModalHeader toggle={handleCloseModal}>Revise File</ModalHeader>
      <ModalBody>
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChangeAccordin("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>
              Upload a new edition
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <div className="dropzone-card">
              <div className="dropzone">
                <div {...getRootProps({ className: "dropzone-file-btn" })}>
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
              </div>
              <div className="dropzone-content" style={thumbsContainer}>
                {Thumbs}
              </div>
            </div>
            {/* <DropZone /> */}
            <div className={classes.version}>
              <TextField
                placeholder="Version"
                value={version}
                onChange={handleChangeVersion}
              />
              {/* <Chip
                    size="small"
                    icon={<DynamicFeedIcon />}
                    label={`Suggestion: ${suggestion}`}
                    color="primary"
                    className={classes.chip}
                  /> */}
            </div>
            <Button
              outline={files.length > 0 ? false : true}
              color={"primary"}
              onClick={handleUploadFile}
            >
              Upload
            </Button>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChangeAccordin("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>Version History</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <VersionSection content={content} current={current} />
          </AccordionDetails>
        </Accordion>
      </ModalBody>
    </Modal>
  );
};
export default ReviseModal;
